import { useAppSelector } from 'app/hooks';

export default function usePendingCompatibilityAdd(
  combinationId: number | null | undefined
): boolean {
  return useAppSelector(
    (state) =>
      combinationId != null &&
      state.systems.pendingCompatibilityAddIds.includes(combinationId)
  );
}
